<script lang="ts" setup>

definePageMeta({layout: "home-design"});

const route = useRoute();

const path = route.path.toString();
const page: any = await useHomeDesignUri(path);

const contactFormProps = {
  formPosition: ['left'],
  backgroundColor: '#8B8C6A',
  showSocialMediaIcons: true,
  textColors: {
    titleColor: '#E3DCCC',
    bodyColor: '#E3DCCC',
    iconTitleColor: '#E3DCCC',
    iconColor: '#8b8c6a',
    iconBackgroundColor: '#E3DCCC'
  }
}

useSeoData(page?.seo || {});
</script>
<template>
  <section class="bg-bottom-right">
    <div class="section-spacer-lg"></div>
    <HomeDesignTabSection
    :enquiryForm="2"
    :homeDesignCategories="page?.homeDesignCategories"
    :homeDesignDetails="page?.homeDesignDetails"
    :title="page?.title"/>
    <div class="section-spacer"></div>
    <Accordion :description="page?.accordion?.accordionDescription" :title="page?.accordion?.accordionTitle"
    :items="page?.accordion?.accordionItems"/>
    <div class="section-spacer"></div>
    <ContactForm v-bind="contactFormProps" :bgOnMobile="true"/>
    <div class="section-spacer"></div>
    <Newsletter :isEnabled="true" :overFlowSection="true"/>
  </section>
</template>
